<script>
import create from '../utils/create'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import TreeSelect from '@riophae/vue-treeselect'

export default create({
  name: 'tree-select',
  mixins: [TreeSelect]
})
</script>
